import "./header.scss";

import React, { useState, useEffect, Fragment } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

import moment from "jalali-moment";

import logo from "../../assets/icons/logo-final.png";
import instaIcon from "../../assets/images/icons/insta-dark.svg";
import telIcon from "../../assets/images/icons/telegram-dark.svg";
import phoneIcon from "../../assets/icons/phone.png";
import clockIcon from "../../assets/icons/clock.svg";
import calendarIcon from "../../assets/icons/calendar.svg";
import enLogo from "../../assets/icons/en-logo.png";
import faLogo from "../../assets/icons/fa-logo.png";
import SideMenu from "../SideMenu";

const Header = ({ configs }) => {
  // State for present time
  const [presentTime, setPresentTime] = useState("");
  // states
  const [showSideMenu, setShowSideMenu] = useState(false);

  const location = useLocation();

  // update present time every minute
  useEffect(() => {
    const interval = setInterval(
      () => {
        const currentTime = moment().locale("fa").format("HH:mm");
        setPresentTime(currentTime);
      },
      [],
      60000
    ); // Update every minute

    // Clear the interval when the component is unmounted
    return () => clearInterval(interval);
  }, []);

  // handlers

  // Get today's date in Persian
  const today = moment().locale("fa");

  // Get the day, month, and year separately
  const day = today.format("D");
  const month = today.format("MMMM");
  const year = today.format("YYYY");

  return (
    <Fragment>
      <header className="header">
        <div className="logo">
          <Link to="/">
            <img className="main-logo" src={logo} alt="logo" />
          </Link>
          <div className="flex items-center justify-start">
            <p className="main-title">
              <Link to="/">
                <img className="fa-logo" src={faLogo} alt="en-logo" />
              </Link>
            </p>
            <div className="sub-title">
              <Link to="/">
                <img className="en-logo" src={enLogo} alt="en-logo" />{" "}
              </Link>
            </div>
          </div>
        </div>
        <nav className="nav">
          <ul>
            <li
              className={`forms menu-item ${
                location.pathname === "/" ? "isActive" : ""
              }`}
            >
              <NavLink to="/" className="link">
                <span>صفحه اصلی</span>
              </NavLink>
            </li>
            <li
              className={`gallery menu-item ${
                location.pathname === "/all-prices" ? "isActive" : ""
              }`}
            >
              <NavLink to="/all-prices" className="link">
                <span>نرخ ها</span>
              </NavLink>
            </li>
            <li
              className={`about-us menu-item ${
                location.pathname === "/about-us" ? "isActive" : ""
              }`}
            >
              <NavLink to="/about-us" className="link">
                <span>درباره ما</span>
              </NavLink>
            </li>
          </ul>
        </nav>
        <div className="date-time">
          <div className="social br-left">
            <a href="about-us">
              <img alt="phone" src={phoneIcon} />
            </a>
            <a href={`https://t.me/${configs?.telegram}`}>
              <img alt="social" src={telIcon} />
            </a>
            <a href={`https://instagram.com/${configs?.instagram}`}>
              <img alt="social" src={instaIcon} />
            </a>
          </div>{" "}
          {/* <img className="dt-img" src={calendarIcon} alt="calendar" /> */}
          <span className="mx-4 font-white">
            {day} {month} {year}
          </span>
          {/* <img className="dt-img" src={clockIcon} alt="clock" /> */}
          <span className="font-white">{presentTime}</span>
        </div>
        <SideMenu
          showSideMenu={showSideMenu}
          setShowSideMenu={setShowSideMenu}
        />
      </header>
    </Fragment>
  );
};

export default Header;
